import { useEffect, useState } from 'react';

import { createNativeStackNavigator } from '@react-navigation/native-stack';
import ROUTE from './routes';
import { PublicStackParamList } from './types';
import GetStarted from '@app/screens/GetStarted/GetStarted';
import { Platform, Text } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import BootSplash from "react-native-bootsplash";
import { useAppSelector } from '@app/store/hooks';
import { lazy } from "react";
import LoginScreen from '@app/screens/Login/Login';


const LoginOTPScreen = lazy(() => import("@app/screens/LoginOTP/OTP"));
const MfdShareLinkInit = lazy(() => import("@app/screens/MfdShareLinkInit/MfdShareLinkInit"));



const Stack = createNativeStackNavigator<PublicStackParamList>();

const PublicRoutes = () => {

  const [isLoading, setIsLoading] = useState(true); 
  const [shownGetStarted, setShownGetStarted] = useState(false);
  const {show_lms_revamp_dev,show_lms_revamp} = useAppSelector(state=>state.firebaseParams)
  const {isMfdShareLink} = useAppSelector(state=>state.platformParams)

  useEffect(() => {
    const checkGetStarted = async () => {
      if (Platform.OS === 'web') {
        setIsLoading(false);
        return;
      }
      try {
        const value = await AsyncStorage.getItem('first_time');
        setShownGetStarted(value === 'true');
      } catch (error) {
        console.error("Error checking AsyncStorage", error);
      } finally {
        setIsLoading(false);
        // BootSplash.hide({ fade: true });
      }
    };
  
    checkGetStarted();
  }, [show_lms_revamp_dev, show_lms_revamp]);


  if(isLoading) {
    // this will never be shown as splash will be kept on till this part
    // this is to let the initialRouteName resolve properly
    return null;
  }

  const getInitialRoute = () => {
    if(isMfdShareLink) {
      return ROUTE.MFD_SHARE_LINK_INIT;
    }
    if(!shownGetStarted && Platform.OS !== 'web') {
      return 'GET_STARTED';
    }
    return ROUTE.LOGIN_MOBILE_NUMBER_SCREEN;
  }

  return (
    <Stack.Navigator 
      initialRouteName={getInitialRoute()}
      screenOptions={{
        title: 'Volt - Unlock cash from your mutual funds saving',
        // animation: 'slide_from_right', // iOS-like horizontal slide animation
        // gestureEnabled: true,         // Enable swipe gestures
        // gestureDirection: 'horizontal',
      }}>
      <Stack.Screen
        name="GET_STARTED"
        component={GetStarted}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LOGIN_MOBILE_NUMBER_SCREEN}
        component={LoginScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.LOGIN_OTP_SCREEN}
        component={LoginOTPScreen}
        options={{ headerShown: false }}
      />
      <Stack.Screen
        name={ROUTE.MFD_SHARE_LINK_INIT}
        component={MfdShareLinkInit}        
        options={{ headerShown: false }}
      />
    </Stack.Navigator>
  );
};
export default PublicRoutes;
